import { render, staticRenderFns } from "./QuotationTemplateList.vue?vue&type=template&id=3849d102&scoped=true"
import script from "./QuotationTemplateList.vue?vue&type=script&lang=js"
export * from "./QuotationTemplateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849d102",
  null
  
)

export default component.exports